module.exports = __webpack_public_path__ + "img/0015.d71009a1.png";